import {
  STORE_RECEIPTS_DATA,
  UPLOAD_PROVISIONAL_RECEIPT,
  UPLOAD_PROVISIONAL_RECEIPT_SUCCESS,
  GET_PROVISIONAL_RECEIPTS,
  GET_PROVISIONAL_RECEIPTS_SUCCESS,
  GET_TAX_WITHHOLDINGS_TYPES,
  GET_TAX_WITHHOLDINGS_TYPES_SUCCESS,
  CLEAR_RECEIPTS_DATA,
  SIGNOUT_USER_SUCCESS,
  DELETE_PROVISIONAL_RECEIPT_SUCCESS,
  RESET_DELETE_RECEIPT_SUCCESS,
  GET_PROVISIONAL_RECEIPTS_BY_FILTER,
  GET_PROVISIONAL_RECEIPTS_BY_FILTER_SUCCESS,
  GET_PROVISIONAL_RECEIPTS_BY_FILTER_ERROR,
  EXPORT_PROVISIONAL_RECEIPTS,
  EXPORT_PROVISIONAL_RECEIPTS_SUCCESS,
  EXPORT_PROVISIONAL_RECEIPTS_ERROR,
  UPLOAD_PROVISIONAL_RECEIPT_ERROR,
  RESEND_PROVISIONAL_RECEIPT_EMAIL,
  RESEND_PROVISIONAL_RECEIPT_EMAIL_SUCCESS,
  RESEND_PROVISIONAL_RECEIPT_EMAIL_ERROR,
  GET_PROVISIONAL_RECEIPT_BY_ID,
  GET_PROVISIONAL_RECEIPT_BY_ID_SUCCESS,
  GET_PROVISIONAL_RECEIPT_BY_ID_ERROR,
  CLEAR_SELECTED_PROVISIONAL_RECEIPT,
} from '../constants/ActionsTypes'

const initialState = {
  selectedReceipts: [],
  total: 0,
  isReceiptUploadedSuccessfully: false,
  taxWithholdingsTypes: null,
  isExporting: false,
  deleteReceiptSuccess: false,
  skipLocalStorageUpdate: false,
  isUploadingProvisionalReceipt: false,
  resendingEmailId: null,
}

const addReceipt = (state, payload) => {
  const totalWithDiscount = parseFloat(payload.totalWithDiscount) || 0

  const adjustedTotalWithDiscount =
    payload.receiptType !== 'DG' ? totalWithDiscount : -Math.abs(totalWithDiscount)

  const total = (parseFloat(state.total) + adjustedTotalWithDiscount).toFixed(2)

  return {
    ...state,
    selectedReceipts: [...state.selectedReceipts, payload],
    total: parseFloat(total),
  }
}

const updateReceipt = (state, payload) => {
  const receiptToUpdate = state.selectedReceipts.find((receipt) => receipt.key === payload.key)

  const newTotalWithDiscount =
    payload.receiptType !== 'DG' ? payload.totalWithDiscount : -Math.abs(payload.totalWithDiscount)
  const oldTotalWithDiscount = receiptToUpdate
    ? receiptToUpdate.receiptType !== 'DG'
      ? receiptToUpdate.totalWithDiscount
      : -Math.abs(receiptToUpdate.totalWithDiscount)
    : 0

  const diff = newTotalWithDiscount - oldTotalWithDiscount

  const updatedReceipts = state.selectedReceipts.map((receipt) => {
    if (receipt.key === payload.key) {
      return { ...receipt, ...payload }
    }
    return receipt
  })

  const total = parseFloat((state.total + diff).toFixed(2))
  return {
    ...state,
    selectedReceipts: updatedReceipts,
    total,
  }
}

const deleteReceipt = (state, payload) => {
  const receiptToDelete = state.selectedReceipts.find((receipt) => receipt.key === payload.key)
  const totalWithDiscount =
    payload.receiptType !== 'DG'
      ? receiptToDelete.totalWithDiscount
      : -Math.abs(receiptToDelete.totalWithDiscount)
  const total = parseFloat((state.total - totalWithDiscount).toFixed(2))
  const updatedReceipts = state.selectedReceipts.filter((receipt) => receipt.key !== payload.key)

  return {
    ...state,
    selectedReceipts: updatedReceipts,
    total,
    success: false,
    sellerReceipts: null,
    isLoadingGetProvisionalReceipts: false,
  }
}

const clearReceiptsData = () => {
  return {
    ...initialState,
    isReceiptUploadedSuccessfully: true,
    skipLocalStorageUpdate: true,
  }
}

function rootReducer(state = initialState, action) {
  let newState

  switch (action.type) {
    case STORE_RECEIPTS_DATA: {
      const { payload, operation } = action

      switch (operation) {
        case 'add':
          newState = addReceipt(state, payload)
          break
        case 'update':
          newState = updateReceipt(state, payload)
          break
        case 'delete':
          newState = deleteReceipt(state, payload)
          break
        default:
          newState = state
      }
      break
    }
    case UPLOAD_PROVISIONAL_RECEIPT:
      newState = {
        ...state,
        isReceiptUploadedSuccessfully: false,
        isUploadingProvisionalReceipt: true,
      }
      break
    case UPLOAD_PROVISIONAL_RECEIPT_SUCCESS:
      newState = clearReceiptsData()
      break
    case UPLOAD_PROVISIONAL_RECEIPT_ERROR:
      newState = {
        ...state,
        isReceiptUploadedSuccessfully: false,
        isUploadingProvisionalReceipt: false,
      }
      break
    case GET_PROVISIONAL_RECEIPTS:
      return { ...state, isLoadingGetProvisionalReceipts: true }
    case GET_PROVISIONAL_RECEIPTS_SUCCESS:
      return {
        ...state,
        sellerReceipts: action.payload.data.receipts,
        isLoadingGetProvisionalReceipts: false,
      }
    case GET_PROVISIONAL_RECEIPTS_BY_FILTER:
      return { ...state, provisionalReceipts: null, isLoadingGetProvisionalReceipts: true }
    case GET_PROVISIONAL_RECEIPTS_BY_FILTER_SUCCESS:
      return {
        ...state,
        provisionalReceipts: action.payload,
        isLoadingGetProvisionalReceipts: false,
      }
    case GET_PROVISIONAL_RECEIPTS_BY_FILTER_ERROR:
      return {
        ...state,
        provisionalReceipts: null,
        isLoadingGetProvisionalReceipts: false,
      }
    case GET_TAX_WITHHOLDINGS_TYPES:
      newState = { ...state, taxWithholdingsTypes: null }
      break
    case GET_TAX_WITHHOLDINGS_TYPES_SUCCESS:
      newState = { ...state, taxWithholdingsTypes: action.payload.response.data }
      break
    case CLEAR_RECEIPTS_DATA:
      newState = { ...state, selectedReceipts: [], total: 0 }
      break
    case SIGNOUT_USER_SUCCESS:
      newState = { ...state, selectedReceipts: [], total: 0 }
      break
    case DELETE_PROVISIONAL_RECEIPT_SUCCESS:
      newState = { ...state, deleteReceiptSuccess: true }
      break
    case RESET_DELETE_RECEIPT_SUCCESS:
      newState = { ...state, deleteReceiptSuccess: false }
      break
    case EXPORT_PROVISIONAL_RECEIPTS:
      return { ...state, isExporting: true }
    case EXPORT_PROVISIONAL_RECEIPTS_SUCCESS:
      return { ...state, isExporting: false }
    case EXPORT_PROVISIONAL_RECEIPTS_ERROR:
      return { ...state, isExporting: false }
    case RESEND_PROVISIONAL_RECEIPT_EMAIL:
      return { ...state, resendingEmailId: action.payload }
    case RESEND_PROVISIONAL_RECEIPT_EMAIL_SUCCESS:
      return { ...state, resendingEmailId: null }
    case RESEND_PROVISIONAL_RECEIPT_EMAIL_ERROR:
      return { ...state, resendingEmailId: null }
    case GET_PROVISIONAL_RECEIPT_BY_ID:
      return { ...state, isLoadingGetProvisionalReceipt: true }
    case GET_PROVISIONAL_RECEIPT_BY_ID_SUCCESS:
      return { ...state, isLoadingGetProvisionalReceipt: false, selectedReceipt: action.payload }
    case GET_PROVISIONAL_RECEIPT_BY_ID_ERROR:
      return {
        ...state,
        isLoadingGetProvisionalReceipt: false,
        selectedReceipt: null,
        error: action.payload,
      }
    case CLEAR_SELECTED_PROVISIONAL_RECEIPT:
      return { ...state, selectedReceipt: null }
    default:
      newState = state
  }

  return { ...newState, skipLocalStorageUpdate: false }
}

export default rootReducer
